import request from '@/utils/request'

export function customerItems (params) {
  return request({
    url: '/amrep/customer/items',
    method: 'get',
    params
  })
}

export function customerCreate (data) {
  return request({
    url: '/amrep/customer/create',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/customer.js